var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackpage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09301 20C8.86583 20 8.63865 19.9163 8.4593 19.737L1.20147 12.4791C0.854719 12.1324 0.854719 11.5585 1.20147 11.2117L8.4593 3.95391C8.80605 3.60716 9.37998 3.60716 9.72679 3.95391C10.0735 4.30066 10.0735 4.87459 9.72679 5.22134L3.10261 11.8454L9.72679 18.4695C10.0735 18.8163 10.0735 19.3902 9.72679 19.737C9.55933 19.9163 9.32019 20 9.09301 20Z",
    fill: "#2D3043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1618 12.7423H2.03837C1.54814 12.7423 1.1416 12.3357 1.1416 11.8455C1.1416 11.3553 1.54814 10.9487 2.03837 10.9487H22.1618C22.652 10.9487 23.0585 11.3553 23.0585 11.8455C23.0585 12.3357 22.652 12.7423 22.1618 12.7423Z",
    fill: "#2D3043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpage);
export default __webpack_public_path__ + "static/media/backpage.966ef3c942ec68db551754ae2624ef11.svg";
export { ForwardRef as ReactComponent };